module.exports = __webpack_public_path__ + "img/icon-jcb.ac6a71d0.svg";